import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6d4a77c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c6d4a77c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d4a77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d4a77c')) {
      api.createRecord('c6d4a77c', component.options)
    } else {
      api.reload('c6d4a77c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6d4a77c&scoped=true&", function () {
      api.rerender('c6d4a77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nc/page/index.vue"
export default component.exports